import { render, staticRenderFns } from "./No04.vue?vue&type=template&id=5cdb7440&scoped=true"
import script from "./No04.vue?vue&type=script&lang=js"
export * from "./No04.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cdb7440",
  null
  
)

export default component.exports